var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStrikethrough(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5439 11.7204L9.79358 15.9774C9.72337 16.3758 9.37729 16.6662 8.97281 16.6662C8.45467 16.6662 8.06212 16.1984 8.15204 15.6882L9.10469 10.282L3.51969 4.69704C3.19391 4.37126 3.19409 3.84301 3.5201 3.51746C3.84579 3.19224 4.3734 3.19242 4.69885 3.51788L16.483 15.302C16.8084 15.6274 16.8084 16.155 16.483 16.4804C16.1576 16.8058 15.6301 16.8058 15.3047 16.4804L10.5439 11.7204ZM9.81219 6.27454L10.0372 4.99954H8.53719L6.87052 3.33288H15.8347C16.2949 3.33288 16.668 3.70597 16.668 4.16621C16.668 4.62645 16.2949 4.99954 15.8347 4.99954H11.7289L11.2514 7.71371L9.81219 6.27454Z",
    fill: "#2C304B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrikethrough);
export default __webpack_public_path__ + "static/media/strikethrough.daa6b4a25dd680e1b6b5118cb57fa412.svg";
export { ForwardRef as ReactComponent };